module.exports = __webpack_public_path__ + "media/components/stylesheets/BrandonText-Bold-0c0b81b31eb443992e7a995ed0c31d94.woff";